import { WrapModes } from '@taxdown/piccolo-web';
import { TAXDOWN_ASSETS_DOMAIN } from 'Constants/domains';

// eslint-disable-next-line no-shadow
export enum SliderType {
  CONFIDENCE = 'confidence',
  ALONE = 'alone',
  DEVOLUTION = 'devolution',
}

export const sliderItems = [
  {
    type: SliderType.DEVOLUTION,
  },
  {
    type: SliderType.CONFIDENCE,
  },
  {
    type: SliderType.ALONE,
  },
];

export const ImgUrls = {
  [SliderType.CONFIDENCE]: `${TAXDOWN_ASSETS_DOMAIN}/illustrations/default/shield.svg`,
  [SliderType.ALONE]: `${TAXDOWN_ASSETS_DOMAIN}/illustrations/default/certificate.svg`,
  [SliderType.DEVOLUTION]: `${TAXDOWN_ASSETS_DOMAIN}/illustrations/default/money_s.png`,
};

export const SlidersMode = {
  [SliderType.CONFIDENCE]: WrapModes.warm_gradient,
  [SliderType.ALONE]: WrapModes.success,
  [SliderType.DEVOLUTION]: WrapModes.warm_gradient,
};
